import { PetsInsuredCivilLiabilityToSave } from '../PetsInsuredCivilLiabilityToSave'

export class SaveCivilLiabilityResponsibleRequest {
  /** (obligatorio, UUID): Identificador único de la cotización. Ejemplo: "23423-643hbf-74834hj". */
  quotationId: string

  /** Lista de asegurados de Responsabilidad Civil a guardar. Aunque sea una lista, solo se esperará un asegurado, ya que, a día de hoy, aunque haya varias mascotas aseguradas, la responsabilidad civil de todas ellas irá asociada a un único asegurado de RC. Cuando el titular coincide con el asegurado de RC solo será obligatorio informar el campo isPolicyHolder a True y no se tendrá en cuenta el resto de campos.  */
  insureds: PetsInsuredCivilLiabilityToSave

  constructor(data: any = {}) {
    this.quotationId = data.quotationId
    this.insureds = data.insureds?.map((i: any) => new PetsInsuredCivilLiabilityToSave(i)) || []
  }
}
